import Loadable from '../../components/loadable';

const ShowGradingEvent = Loadable({
  loader: () => import('../../pages/gradings/show_grading_event'),
  type: 'block',
});

angular.module('gym').value('ShowGradingEvent', ShowGradingEvent);

const ConfirmBulkRsvpUpdateModal = Loadable({
  loader: () => import('../../pages/gradings/confirm_bulk_rsvp_update_modal'),
  type: 'modal',
});

angular.module('gym').value('ConfirmBulkRsvpUpdateModal', ConfirmBulkRsvpUpdateModal);

const BulkAddToGradingEventModal = Loadable({
  loader: () => import('../../pages/gradings/bulk_add_to_grading_event_modal'),
  type: 'modal',
});

angular.module('gym').value('BulkAddToGradingEventModal', BulkAddToGradingEventModal);

const UnableToGradeModal = Loadable({
  loader: () => import('../../pages/gradings/unable_to_grade_modal'),
  type: 'modal',
});

angular.module('gym').value('UnableToGradeModal', UnableToGradeModal);
